import { render } from "./ButtonComingSoon.vue?vue&type=template&id=73af555a"
import script from "./ButtonComingSoon.vue?vue&type=script&lang=js"
export * from "./ButtonComingSoon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__